export default __webpack_public_path__ + "static/media/SveaTaxi.db7d4303.png";